// ブラウザの戻る・進む禁止
export const handleBrowserBack = () => {
  // ダミー履歴を追加
  history.pushState(null, '', null);
  // ダミー履歴の追加を検出するリスナー
  window.addEventListener('popstate', restrictionBrowserBack);
};

// ブラウザバック禁止
export const restrictionBrowserBack = () => {
  history.go(1);
};

// ブラウザバック禁止解除
export const releaseBrowserBack = () => {
  window.removeEventListener('popstate', restrictionBrowserBack);
};

// ブラウザバック再度禁止
export const banBrowserBack = () => {
  window.setTimeout(() => {
    handleBrowserBack();
  }, 100);
};
